import { Environment, PerspectiveCamera } from '@react-three/drei'
import { Canvas, useThree } from '@react-three/fiber'
import { useSearch } from '@tanstack/react-router'
import { usePointCloudContext } from 'features/pointClouds'
import { initializeCamera } from 'pages/pointClouds/utils'
import React, { useEffect, useState } from 'react'
import * as THREE from 'three'

interface PointCloudCanvasProps {
  children: React.ReactNode
}

export const PointCloudCanvas: React.FC<PointCloudCanvasProps> = ({
  children,
}) => {
  return (
    <div
      style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100%',
        height: '100%',
      }}>
      <Canvas>
        <CanvasContent>{children}</CanvasContent>
      </Canvas>
    </div>
  )
}

const CanvasContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { activePointCloud, camera: cameraFromContext } = usePointCloudContext()
  const [isInitialCameraSetupDone, setIsInitialCameraSetupDone] =
    useState(false)
  const { camera: threeCamera } = useThree()

  const queryParams = useSearch({ strict: false })

  useEffect(() => {
    if (
      !threeCamera ||
      !activePointCloud?.data?.default_settings ||
      isInitialCameraSetupDone
    ) {
      return
    }

    initializeCamera(
      threeCamera as THREE.PerspectiveCamera,
      queryParams,
      activePointCloud.data.default_settings
    )

    setIsInitialCameraSetupDone(true)
  }, [threeCamera, activePointCloud, queryParams, isInitialCameraSetupDone])

  useEffect(() => {
    if (threeCamera && cameraFromContext.current !== threeCamera) {
      cameraFromContext.current = threeCamera as THREE.PerspectiveCamera
    }
  }, [threeCamera, cameraFromContext])

  return (
    <>
      <Environment preset='sunset' background={true} backgroundBlurriness={1} />
      <PerspectiveCamera makeDefault fov={75} near={0.1} far={10000} />
      {children}
    </>
  )
}
